import React from 'react';
import './UsersSkeleton.scss';

const SkeletonLoader = () => {
  return (
    <div className="skeleton-users">
      <div className="skeleton-hospitals-container">
        {[...Array(2)].map((_, hospitalIndex) => (
          <div key={hospitalIndex} className="skeleton-hospital-item">
            <div className="skeleton-hospital-header">
              <div className="skeleton-icon"></div>
              <div className="skeleton-title"></div>
            </div>
            <div className="skeleton-departments-list">
              {[...Array(3)].map((_, deptIndex) => (
                <div key={deptIndex} className="skeleton-department-item-container">
                  <div className="skeleton-department-item">
                    <div className="skeleton-department-info">
                      <div className="skeleton-icon"></div>
                      <div className="skeleton-text"></div>
                    </div>
                    <div className="skeleton-department-actions">
                      <div className="skeleton-button"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonLoader;